import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { groupSt52Quota } from '@/api/api';
import moment from 'moment';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    this.getGroupSt52Quota();
  },
  methods: {
    getGroupSt52Quota: function getGroupSt52Quota() {
      var _this = this;

      groupSt52Quota({
        dataType: 4,
        etime: moment(new Date()).format('YYYY-MM-DD')
      }).then(function (res) {
        if (res.success) {
          var areaList = [];
          var data = {};
          res.result.forEach(function (item) {
            areaList.push(item.paramName);
            var data1 = item.waterInlet != 0 ? (item.electConsum / item.waterInlet).toFixed(2) : 0;
            data[item.paramName] = [item.waterInlet, item.waterOutlet, item.electConsum, data1];
          });

          _this.initBarChart(areaList, data);
        }
      });
    },
    initBarChart: function initBarChart(geoCoordMap, dataList) {
      var colors = [['#1DE9B6', '#F46E36', '#04B9FF', '#5DBD32', '#FFC809', '#FB95D5', '#BDA29A', '#6E7074', '#546570', '#C4CCD3'], ['#37A2DA', '#67E0E3', '#32C5E9', '#9FE6B8', '#FFDB5C', '#FF9F7F', '#FB7293', '#E062AE', '#E690D1', '#E7BCF3', '#9D96F5', '#8378EA', '#8378EA'], ['#DD6B66', '#759AA0', '#E69D87', '#8DC1A9', '#EA7E53', '#EEDD78', '#73A373', '#73B9BC', '#7289AB', '#91CA8C', '#F49F42']];
      var colorIndex = 0;
      var year = ['进水量', '出水量', '用电总量', '吨水能耗'];
      var mapData = [[], [], [], []];
      /*柱子Y名称*/

      var categoryData = [];
      var barData = [];
      geoCoordMap.forEach(function (item) {
        categoryData.push(item);
        mapData[0].push({
          'year': '进水量',
          'name': item,
          'value': dataList[item][0]
        });
        mapData[1].push({
          'year': '出水量',
          'name': item,
          'value': dataList[item][1]
        });
        mapData[2].push({
          'year': '用电总量',
          'name': item,
          'value': dataList[item][2]
        });
        mapData[3].push({
          'year': '吨水能耗',
          'name': item,
          'value': dataList[item][3]
        });
      });

      for (var i = 0; i < mapData.length; i++) {
        barData.push([]);

        for (var j = 0; j < mapData[i].length; j++) {
          barData[i].push(mapData[i][j].value);
        }
      }

      var optionXyMap01 = {
        timeline: {
          data: year,
          axisType: 'category',
          autoPlay: true,
          playInterval: 3000,
          left: '10%',
          right: '20%',
          bottom: '2%',
          width: '85%',
          //  height: null,
          label: {
            normal: {
              textStyle: {
                color: '#ddd'
              }
            },
            emphasis: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          symbolSize: 10,
          lineStyle: {
            color: '#555'
          },
          checkpointStyle: {
            borderColor: '#777',
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: '#666',
              borderColor: '#666'
            },
            emphasis: {
              color: '#aaa',
              borderColor: '#aaa'
            }
          }
        },
        baseOption: {
          animation: true,
          animationDuration: 1000,
          animationEasing: 'cubicInOut',
          animationDurationUpdate: 1000,
          animationEasingUpdate: 'cubicInOut',
          grid: {
            right: '20%',
            left: '20%',
            top: '18%',
            bottom: '15%',
            width: '70%'
          },
          tooltip: {
            trigger: 'axis',
            // hover触发器
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',
              // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: 'rgba(150,150,150,0.1)' //hover颜色

              }
            }
          }
        },
        options: []
      };

      for (var n = 0; n < year.length; n++) {
        optionXyMap01.options.push({
          xAxis: {
            type: 'value',
            scale: true,
            position: 'top',
            min: 0,
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              margin: 2,
              textStyle: {
                color: '#aaa'
              }
            }
          },
          yAxis: {
            type: 'category',
            //  name: 'TOP 20',
            nameGap: 16,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#ddd'
              }
            },
            axisTick: {
              show: false,
              lineStyle: {
                color: '#ddd'
              }
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: '#ddd'
              }
            },
            data: categoryData
          },
          series: [//柱状图
          {
            zlevel: 1.5,
            type: 'bar',
            barWidth: '20%',
            symbol: 'none',
            label: {
              show: true,
              position: 'insideLeft',
              color: '#ffffff'
            },
            itemStyle: {
              normal: {
                color: colors[colorIndex][n]
              }
            },
            data: barData[n]
          }]
        });
      }

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(optionXyMap01);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};